// extracted by mini-css-extract-plugin
export default {"table-container":"CategoryList_table-container__Vc2tS","zr-table":"CategoryList_zr-table__kMQoj","table-header":"CategoryList_table-header__V-Nhn"};